'use strict';

var $ = require('jquery');
var HistoryDrawerDirective = function HistoryDrawerDirective($rootScope) {
  return {
    restrict: 'E',
    template: require('../templates/history-drawer.html'),
    controller: 'HistoryDrawerController',
    scope: {
      entityData: '=',
      headerFormat: '@'
    },
    link: function link(scope, element) {
      element.on('click', 'a.readOnlyRule', function (e) {
        e.preventDefault();
        $rootScope.$broadcast('read-only-rule:show', $(this).data('uid'));
        e.stopPropagation();
        return false;
      });
    }
  };
};
HistoryDrawerDirective.$inject = ['$rootScope'];
module.exports = HistoryDrawerDirective;